import { IFindTicketForm } from 'entities/ticket/models/find-ticket/models'

import { prepareCabinClass } from './get-search-form'

export const prepareCountPassengers = (searchParams: IFindTicketForm) => {
  return {
    adults: searchParams.adult,
    children: searchParams.child,
    infants: searchParams.infant,
    infants_with_place: searchParams.infants_with_place,
    cabin_class: prepareCabinClass(searchParams?.cabin_class as string),
  }
}
